import React from "react";

export const highlightKeyword = (text: string, keyword?: string): React.ReactNode => {
  if (!keyword) return text;
  const regex = new RegExp(`(${keyword})`, "gi");
  const parts = text.split(regex);

  return parts.map((part, i) =>
    part.toLowerCase() === keyword.toLowerCase() ? (
      <mark
        key={i}
        style={{
          backgroundColor: "#bd00cd2e",
          padding: "0 2px",
          borderRadius: "2px",
        }}
      >
        {part}
      </mark>
    ) : (
      part
    )
  );
};
